export default "__VITE_ASSET__d2f95b02__"